// extracted by mini-css-extract-plugin
module.exports = {"root":"Signout_root__cYRUz","container":"Signout_container__18UWj","text":"Signout_text__25wH_"};